<template>
    <uw-content title="退货订单">

        
        <uw-table>

            
            <template slot="search">
                <el-input @input="$lodash.debounce(TableSearch, 500)" v-model="search.number" clearable  size="mini" placeholder="退货单编号查询"></el-input>
            </template>

            
            <template slot="button">
                <el-button type="primary" size="mini" @click="$refs.xTable.print()" >打印</el-button>
                <el-button type="primary" size="mini" @click="$refs.xTable.openExport()" >导出</el-button>
            </template>

            
            <template slot="data">
                <vxe-table
                    ref="xTable"
                    :data="table"
                    :loading="loading"
                    :export-config="{}"
                    :print-config="{}"
                    :seq-config="{startIndex: page.size * (page.current - 1)}"
                    height="100%">

                    
                    <vxe-column width="60" type="seq" title="序号"></vxe-column>

                    
                    <vxe-column width="90" title="审核状态" align="center">
                        <template #default="{ row }">
                            <el-tag v-if="row.confied_state == 0" size="mini" effect="dark" type="info">待审核</el-tag>
                            <el-tag v-if="row.confied_state == 1" size="mini" effect="dark">已同意</el-tag>
                            <el-tag v-if="row.confied_state == 2" size="mini" effect="dark" type="danger">已拒绝</el-tag>
                        </template>
                    </vxe-column>

                    
                    <vxe-column min-width="160" title="退货单编号">
                        <template #default="{ row }">
                            <el-link @click="$refs.backDrawer.Open(row.id)" type="primary">{{ row.number }}</el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column min-width="100" field="date" title="退货日期"></vxe-column>
                    <vxe-column min-width="100" field="money" title="退货金额"></vxe-column>
                    <vxe-column min-width="120" field="reason" title="退货原因"></vxe-column>
                    <vxe-column min-width="120" field="describe" title="备注"></vxe-column>

                    
                    <vxe-column width="140" field="updated_at" title="创建时间"></vxe-column>
                    <vxe-column width="80" field="updated_user.name" title="创建人"></vxe-column>
                    <vxe-column width="140" field="created_at" title="更新时间"></vxe-column>
                    <vxe-column width="80" field="created_user.name" title="更新人"></vxe-column>

                </vxe-table>
            </template>

            
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>

        </uw-table>

        
        <ims-product-back-drawer ref="backDrawer" @onChange="TableSearch" />

    </uw-content>
</template>

<script>
export default {
    data () {
        return {
                        loading: false,

            table: [],

                        page: {
                total: 0,
                size: 50,
                current: 1,
            },

                        search: {
                number: null
            },

                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },

    mounted () {
        this.TableSearch()
    },

    methods: {

                TableSearch() {
                        this.loading = true

            this.$http.post(
                '/9api/ims/product-back/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['created_user', 'updated_user']
                }
            ).then(rps => {
                
                                this.page.total = rps.data.total
                this.table = rps.data.body

                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }

                                this.loading = false
            })
        }
    }

}
</script>